// src/pages/Onboarding.js
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

export default function Onboarding() {
  const { sessionId, role } = useParams();
  const navigate = useNavigate();
  const [step, setStep] = useState(1);

  const displayName =
    localStorage.getItem("display_name") ||
    localStorage.getItem("name") ||
    "";

  const textStep1 =
    `👋 Hello ${displayName}\n` +
    "I'm glad you are here.\n\n" +
    "We are now entering an introductory space.\n\n" +
    "Here, I want to get to know you better.\n\n" +
    "Yes, you and your partner.\n" +
    "Both of you have same task, but you stay totaly independent.";

  const textStep2 =
    "One advice before we start. No rush, take your time, be honest, this is confidental space.\n\n" +
    "This will help me guide the next steps more clearly.\n\n" +
    "Iam build in a way where every detail matter, for better outcome.\n" +
    "Let's begin";

  const currentText = step === 1 ? textStep1 : textStep2;

  const [typed, setTyped] = useState("");
  const [index, setIndex] = useState(0);

  useEffect(() => {
    setTyped("");
    setIndex(0);
  }, [step]);

  useEffect(() => {
    if (!currentText) return;

    if (index < currentText.length) {
      const t = setTimeout(() => {
        setTyped(prev => prev + currentText[index]);
        setIndex(i => i + 1);
      }, 34);

      return () => clearTimeout(t);
    }
  }, [index, currentText]);

  return (
    <div
      className="fade-in"
      style={{
        minHeight: "100vh",
        background:
          "radial-gradient(circle at 50% 45%, #123044 0%, #081822 55%, #020608 100%)",
        paddingTop: 80
      }}
    >
      <div
        className="card"
        style={{
          maxWidth: 520,
          margin: "0 auto",
          background: "rgba(18,48,68,0.35)",
          border: "1px solid rgba(245,244,237,0.25)",
          backdropFilter: "blur(8px)"
        }}
      >
        <p
          style={{
            fontFamily: "Cormorant Garamond, serif",
            fontSize: 16,
            fontWeight: 300,
            lineHeight: 1.9,
            letterSpacing: "0.04em",
            color: "#F5F4ED",
            whiteSpace: "pre-wrap",
            minHeight: 450,
            marginBottom: 28
          }}
        >
          {typed}
        </p>

        {step === 1 && (
          <button
            className="btn btn-primary"
            onClick={() => setStep(2)}
          >
            I understand
          </button>
        )}

        {step === 2 && (
          <button
            className="btn btn-primary"
            onClick={() => navigate(`/flow/${sessionId}/${role}`)}
          >
            Begin
          </button>
        )}
      </div>
    </div>
  );
} 
